<script lang="ts" context="module">
  export const matchingProps = [];
</script>

<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import FormStyledButton from '../buttons/FormStyledButton.svelte';
  import FormStyledButtonLikeLabel from '../buttons/FormStyledButtonLikeLabel.svelte';
  import FormCheckboxField from '../forms/FormCheckboxField.svelte';
  import SettingsFormProvider from '../forms/SettingsFormProvider.svelte';
  import ExportImportConnectionsModal from '../modals/ExportImportConnectionsModal.svelte';
  import { showModal } from '../modals/modalTools';
  import { useConfig } from '../utility/metadataLoaders';
  import resolveApi, { resolveApiHeaders } from '../utility/resolveApi';

  export let tabid;

  let uploadFileKey = 0;

  const config = useConfig();

  function handleExportConnections() {
    showModal(ExportImportConnectionsModal, {
      mode: 'export',
    });
  }

  async function handleUploadFile(e) {
    const files = [...e.target.files];

    for (const file of files) {
      const formData = new FormData();
      formData.append('name', file.name);
      formData.append('data', file);

      const fetchOptions = {
        method: 'POST',
        body: formData,
        headers: resolveApiHeaders(),
      };

      const apiBase = resolveApi();
      const resp = await fetch(`${apiBase}/uploads/upload`, fetchOptions);
      const fileData = await resp.json();

      showModal(ExportImportConnectionsModal, {
        mode: 'import',
        uploadedFilePath: fileData.filePath,
      });
    }
    uploadFileKey += 1;
  }
</script>

<SettingsFormProvider>
  <div class="wrapper">
    <h2>Administration &gt; Settings</h2>
    <div>
      <h3>Export</h3>
      <FormStyledButton value="Export connections & settings" on:click={handleExportConnections} skipWidth />
      <br />

      <h3>Import</h3>
      {#key uploadFileKey}
        <FormStyledButtonLikeLabel htmlFor={`uploadSettingsFileButton_${tabid}`} skipWidth
          >Import connections & settings</FormStyledButtonLikeLabel
        >
        <input type="file" id={`uploadSettingsFileButton_${tabid}`} hidden on:change={handleUploadFile} />
      {/key}

      <h3>Audit log</h3>
      <FormCheckboxField
        name="storage.useAuditLog"
        label="Use audit log"
        data-testid="AdminSettingsTab_auditLogCheckbox"
      />
    </div>
    {#if $config?.supportCloudAutoUpgrade}
      <h3>Cloud instance settings</h3>
      <FormCheckboxField
        name="cloud.useAutoUpgrade"
        label="Use auto-upgrade"
        data-testid="AdminSettingsTab_cloudAutoUpgradeCheckbox"
      />
    {/if}
  </div>
</SettingsFormProvider>

<style>
  .wrapper {
    flex: 1;
    margin: 20px;
    margin-top: 0;
    display: flex;
    flex-direction: column;
  }
</style>
